angular.module('memberPortal').controller('PerformedWorkoutsCtrl', ["$scope", "$stateParams", "WorkoutService", "UnitSymbols", "Restangular", function($scope, $stateParams, WorkoutService, UnitSymbols, Restangular) {
  var loadWorkouts;
  $scope.workouts = [];
  $scope.isLoading = true;
  $scope.page = 1;
  $scope.getPersonalBest = function(exercise) {
    return WorkoutService.getPersonalBest(exercise.personal_best);
  };
  $scope.displayTime = function(ex) {
    return moment().startOf('day').hours(ex.actual_hours || 0).minutes(ex.actual_minutes || 0).seconds(ex.actual_seconds || 0).format('HH:mm:ss');
  };
  $scope.displayWeight = function(ex) {
    return parseFloat(ex.actual_weight) + UnitSymbols[ex.actual_weight_unit];
  };
  $scope.getHash = function() {
    return $stateParams.hash || $stateParams.m;
  };
  $scope.loadMore = function() {
    if ($scope.isLoading || $scope.workouts.length >= $scope.total) {
      return;
    }
    $scope.page = $scope.page + 1;
    return loadWorkouts();
  };
  loadWorkouts = function() {
    $scope.isLoading = true;
    return Restangular.all('performed_workouts').getList({
      count: 10,
      page: $scope.page
    }).then(function(workouts) {
      $scope.total = workouts.meta.total;
      $scope.isLoading = false;
      return $scope.workouts = $scope.workouts.concat(workouts.plain());
    });
  };
  return loadWorkouts();
}]);
